import { c as _c } from "react/compiler-runtime";
import { EditableCollectionsType } from "@opensea/graphql";
import { toLowerCase, toUpperCase } from "@opensea/utils";
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
const parser = parseAsStringLiteral(EditableCollectionsType.map(value => toLowerCase(value)));
export function useEditableCollectionsTypeQueryParam(t0) {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    shallow: t2
  } = t1;
  const shallow = t2 === undefined ? true : t2;
  let t3;
  if ($[2] !== shallow) {
    t3 = parseAsArrayOf(parser).withOptions({
      shallow
    }).withDefault([]);
    $[2] = shallow;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [types, setTypesState] = useQueryState(QUERY_PARAM_KEYS.editableCollectionsType, t3);
  let t4;
  if ($[4] !== setTypesState) {
    t4 = async function onSelectType(value) {
      await setTypesState(value ? [toLowerCase(value)] : null);
    };
    $[4] = setTypesState;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onSelectType = t4;
  let t5;
  if ($[6] !== setTypesState) {
    t5 = async function setTypes(values) {
      await setTypesState(values?.length ? [toLowerCase(values[0])] : null);
    };
    $[6] = setTypesState;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const setTypes = t5;
  let t6;
  if ($[8] !== types[0]) {
    t6 = types[0] ? toUpperCase(types[0]) : undefined;
    $[8] = types[0];
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== types) {
    t7 = types.map(toUpperCase);
    $[10] = types;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onSelectType || $[13] !== setTypes || $[14] !== t6 || $[15] !== t7) {
    t8 = {
      type: t6,
      types: t7,
      onSelectType,
      setTypes
    };
    $[12] = onSelectType;
    $[13] = setTypes;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}